// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rF-z","hovered":"sF-z","hoverImage":"tF-z","mainImage":"uF-z","imageNoBackground":"vF-z","fullSizeImage":"wF-z"};